import {Component} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {LocationTableService} from './location-table.service';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {
    ICommonTableAction,
    ICommonTableConfig,
    ICommonTableData
} from '@lib-ui/common-table/models/common-table.interface';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {AddressEditFormComponent} from '@lib-ui/forms/address-edit-form/address-edit-form.component';
import {MatDialog} from '@angular/material/dialog';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';

@Component({
    selector: 'app-location',
    standalone: true,
    imports: [
        CommonTableComponent,
        LoaderComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './location.component.html',
    styleUrl: './location.component.scss'
})
export class LocationComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'address', title: 'Адрес', showToolTip: true },
            { name: 'latitude', title: 'Широта' },
            { name: 'longitude', title: 'Долгота' },
        ],
        showCreateButton: true,
        createButtonLabel: 'Добавить адрес',
    });
    filterConfig: FilterConfig[] = [
        {
            type: 'input',
            label: 'Адрес',
            name: 'address',
        },
        // {
        //     type: 'common-dropdown',
        //     label: 'Компания',
        //     name: 'group.company.id',
        //     commonDropdownConfig: {
        //         service: inject(CompanySelectorService),
        //         formCtrl: new FormControl(),
        //     },
        // },
    ];

    constructor(
        protected locationTableService: LocationTableService,
        private dialog: MatDialog,
    ) {
    }

    applyAction(value: ICommonTableAction): void {
        switch (value.action) {
        case RowAction.CLICK:
            this.openDialog(value.data[0]);
            break;
        case RowAction.CREATE:
            this.openDialog();
            break;
        }
    }

    openDialog(data?: ICommonTableData): void {
        this.dialog.open(AddressEditFormComponent, {
            width: '50%',
            maxHeight: '450px',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe(() => this.locationTableService.updateData(this.tableConfig));
    }

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.locationTableService.updateData(this.tableConfig);
    }
}
